exports = module.exports = require("../../../css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, ".Z3SO5XgmhMBG2B8bKDa8N{display:inline-block;width:6px;height:15px;vertical-align:middle}html[dir=ltr] .Z3SO5XgmhMBG2B8bKDa8N,html[dir=rtl] .Z3SO5XgmhMBG2B8bKDa8N{margin-left:10px;margin-right:10px}", ""]);
// Exports
exports.locals = {
	"showAsItem": "Z3SO5XgmhMBG2B8bKDa8N"
};